import { getConfigs } from "../configs/Config";
import {
  setHelpRequests,
  setNotification,
  removeHelpRequest,
  resolveHelpRequestSuccess,
} from "src/store/features/applications/applicationsSlice";
import { fetchAccessToken, fetchIdToken } from "../utils/Auth";
import { fetchWithFreshSession } from "./AuthService";
import { AppThunk } from "src/redux/store";
import { PostHelpRequestBulkFetch } from "src/types/HelpRequests";

export const getHelpRequestsBulk = (applicationIds: string[]): AppThunk => {
  const { apiKey, baseRoute } = getConfigs();

  const route = `${baseRoute}/help-requests/bulk-fetch`;
  return (dispatch) => {
    const method = "POST";
    const headers = new Headers({
      "Content-type": "application/json",
      Accept: "application/json",
      Authorization: fetchIdToken() || "",
      "x-api-key": apiKey || "",
      "x-access-token": fetchAccessToken() || "",
    });
    const options = {
      method,
      headers,
      body: JSON.stringify({
        applicationIds,
      }),
    };
    fetchWithFreshSession(route, options)
      .then(async (response) => {
        if (!response.ok) {
          console.log(
            `error on getting Help Requests in Bulk: HTTP ${response.status}`
          );
          return;
        }
        const res: PostHelpRequestBulkFetch = await response.json();
        dispatch(
          setHelpRequests({
            helpRequests: res.helpRequests,
          })
        );
      })
      .catch((error) => {
        console.log("error on getting Help Requests in Bulk", error);
      });
  };
};

export const resolveHelpRequest = (application, request): AppThunk => {
  const { apiKey, baseRoute } = getConfigs();

  const route = `${baseRoute}/help-requests/${application.applicationId}/${request.id}/resolve`;

  return (dispatch) => {
    const method = "PUT";
    const headers = new Headers({
      "Content-type": "application/json",
      Accept: "application/json",
      Authorization: fetchIdToken() || "",
      "x-api-key": apiKey || "",
      "x-access-token": fetchAccessToken() || "",
    });
    const options = {
      method,
      headers,
    };
    fetchWithFreshSession(route, options)
      .then((response) => {
        if (!response.ok) {
          dispatch(
            setNotification({
              type: "ERROR",
              title: "Unable to process the Help Request",
              message:
                "There was an error processing the Help Request.\nPlease try again.",
            })
          );
          return;
        }

        dispatch(removeHelpRequest(request));
        dispatch(resolveHelpRequestSuccess({ id: request.id }));
        // Removes help request from the Applications page
        window.localStorage.setItem(
          "HELP_REQUEST_RESOLVED",
          JSON.stringify(request)
        );
        window.localStorage.removeItem("HELP_REQUEST_RESOLVED");
        dispatch(
          setNotification({
            type: "INFO",
            message: `The Help Request was successfully resolved for ${application.unitId} ${request.helpRequestTopic}.`,
          })
        );
      })
      .catch((error) => {
        console.log("error on resolving Help Requests", error);
        dispatch(
          setNotification({
            type: "ERROR",
            title: "Unable to process the Help Request",
            message:
              "There was an error processing the Help Request.\nPlease try again.",
          })
        );
      });
  };
};
